import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customMenu": "",
  "customPath": "",
  "description": "Выгодные условия на замену масла для автомобилей ŠKODA старше 4х лет",
  "huggerTemplate": "default",
  "keywords": "service skoda special winter",
  "name": "winter-service-40",
  "previewInfo": {
    "dateEnd": "",
    "dateStart": "2020-12-25",
    "href": "https://service.skoda-avto.ru/",
    "src": "/m/winter-service-february-prev.jpg",
    "subTitle": "Праздник случится с каждым",
    "tag": "special service",
    "text": "Выгодные условия на замену масла - стоимость 4500 руб. на оригинальные работы и детали для автомобилей ŠKODA старше 4-х лет в феврале.",
    "title": ""
  },
  "title": "Спецпредложение на зимний сервис"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      